<template>
  <div class="flex flex-col gap-2">
    <label
      :for="id"
      class="block text-sm font-medium text-primary"
      :class="{ 'required-label': required }"
      >{{ label }}</label
    >
    <textarea
      ref="textareaRef"
      v-model="model"
      :data-testId="name"
      :name="name"
      v-bind="$attrs"
      class="w-full min-h-[40px] border-b-[1px] border-dark4 text-white placeholder-dark4 focus:outline-none focus:border-primary bg-transparent resize-vertical"
      :placeholder="placeholder"
      style="height: auto"
    />
    <div v-if="error" class="text-red-400">
      {{ error }}
    </div>
  </div>
</template>

<script setup lang="ts">
  import { nextTick, onMounted, ref, watch } from 'vue';

  const model = defineModel<string>();
  const textareaRef = ref<HTMLTextAreaElement | null>(null);

  interface Props {
    label: string;
    id: string;
    name: string;
    placeholder?: string;
    required?: boolean;
    error?: string;
  }

  withDefaults(defineProps<Props>(), {
    placeholder: '',
    required: false,
    error: ''
  });

  const adjustHeight = () => {
    if (textareaRef.value) {
      textareaRef.value.style.height = 'auto';
      textareaRef.value.style.height = `${textareaRef.value.scrollHeight}px`;
    }
  };

  watch(model, () => {
    nextTick(adjustHeight);
  });

  onMounted(adjustHeight);
</script>

<style lang="scss" scoped>
  .required-label::after {
    content: '*';
    margin-left: 0.25rem;
    color: theme('colors.primary');
  }

  textarea {
    display: block;
    overflow: hidden;
    resize: vertical;
    min-height: 40px;
    line-height: 1.5;
    padding: 8px 0;

    &::-webkit-scrollbar {
      display: none;
    }

    &::-webkit-resizer {
      display: none;
    }
  }
</style>
